<template>
  <BreadCrumb page="Beranda > Pendaftaran > Data Keputusan > Lihat Data Keputusan > Ubah data"></BreadCrumb>
  <div class="container content-area">
    <div class="row">
      <div class="col-md-10">
        <h3 class="judul-seksi-sga">Data Hasil Assesment - {{ data.nama_anak }} </h3>
      </div>
      <div class="col-md-2 text-right my-auto">
        <a href="#" @click="toggleview" class="btn btn-sm btn-light"><i class="fa-solid fa-caret-left"></i></a>
      </div>
      <div class="col-12">
        <hr>
      </div>
      <div class="form-general">
        <div class="row">
          <div class="col-md-4">
            <div class="row">
              <div class="col-12 spacer-field-sga">
                <normal-label>No formulir</normal-label>
                <br>
                <normal-label2>{{ data.no_formulir }}</normal-label2>
              </div>
              <div class="col-12 spacer-field-sga">
                <normal-label>Nama Ananda</normal-label>
                <br>
                <normal-label2>{{ data.nama_anak }}</normal-label2>
              </div>
              <div class="col-12 spacer-field-sga">
                <normal-label>Nama Orang Tua</normal-label>
                <ul>
                  <li>
                    <normal-label2>{{ data.nama_ayah }}</normal-label2>
                  </li>
                  <li>
                    <normal-label2>{{ data.nama_ibu }}</normal-label2>
                  </li>
                  <li v-if="data.nama_ayah_tiri">{{ data.nama_ayah_tiri }}</li>
                  <li v-if="data.nama_ibu_tiri">{{ data.nama_ibu_tiri }}</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="row">
              <div class="col-12">
                <label>Dokumen tes assesment: </label>
                <div class="custom-file">
                  <FileLister class="mb-2" v-if="!loading" :filedata="filelist.list" :num-visible="filelist.size"></FileLister>
                  <ProgressBar v-if="isupload" class="mt-2 mb-2" :value="uploadprogress" style="height: 10px;font-size: 14px"></ProgressBar>
                  <FileUpload v-if="showupload"
                              :class="classupload"
                              :fileLimit="1"
                              :showUploadButton="false"
                              :showCancelButton="false"
                              :multiple="false"
                              :chooseLabel="uploadLabel"
                              @before-send="beforeUpload"
                              name="fileupload" :url=urlupload
                              :auto="true" accept="image/jpg,image/jpeg,application/pdf"
                              :maxFileSize="5000000" @progress="onProgress"
                              @upload="onUpload" @select="onSelect"></FileUpload>
                  <keterangan-form>Pilih berkas maksimum berukuran 1024kb. Hanya .jpg atau .pdf</keterangan-form>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <hr>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import FileLister from "@/components/FileLister";
import FileUpload from "primevue/fileupload";
import DashboardServices from "@/services/dashboard.services";
import ProgressBar from 'primevue/progressbar';
export default {
  name: "DataHasilAssesment",
  components: {BreadCrumb,FileLister,FileUpload,ProgressBar},
  props: {
    data: undefined
  },
  emits: ['change-view'],
  data: () => ({
    loading: false,
    message: "",
    messagetrx: "",
    success: false,
    successtrx: false,
    showupload: true,
    isupload: false,
    classupload: '',
    urlupload: '',
    filelist: [],
    uploadLabel:'',
    uploadprogress:0
  }),
  methods: {
    toggleview() {
      this.$emit('change-view', true)
    },
    beforeUpload(request){
      let user = JSON.parse(localStorage.getItem('usergemala'));
      request.xhr.setRequestHeader('Authorization', 'Bearer ' + user.token);
      request.formData.append('paramname','dataassessment');
      request.formData.append('invid',this.data.invcode);
      return request;
    },
    onProgress(event){
      this.isupload = true;
      this.uploadprogress = event.progress;
    },
    onUpload(event){
      let response = event.xhr.response;
      const obj = JSON.parse(response);
      let message = obj.message;
      if(obj.code===1){
        this.classupload='bg-success';
        this.$toast.add({ severity: 'success', summary: message, detail: 'File Uploaded', life: 3000 });
      }else{
        this.classupload='bg-danger';
        this.$toast.add({ severity: 'danger', summary: message, detail: 'File Uploaded', life: 3000 });
      }
      this.isupload = false;
    },
    onSelect(event){
      if(event.files.length >0){
        //this.uploadLabel1 = event.files[0].name;
      }
    },
    getDataUploadedFile(){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = {
        paramname:this.data.invcode,
        filecat:'dataassessment'
      };
      let path = '/dashboard/getListFile';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.success = true;
              if (typeof this.response.data.dataassessment !== 'undefined') {
                this.filelist = this.response.data.dataassessment;
              }
            }else {
              this.success = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    },
  }, mounted() {
    let path = '/dashboard/uploadFile';
    this.urlupload = DashboardServices.generateUrl(path);
    this.getDataUploadedFile()
  }
}
</script>

<style scoped>

</style>